// extracted by mini-css-extract-plugin
export default {"rootApp":"ChatBot_rootApp__aCowL","chatContainer":"ChatBot_chatContainer__dtLnc"};